// Marks a glitch-refresh exit so the resume can skip the fullscreen life
// deduction. Slug-scoped + short TTL so a stale marker never suppresses a
// later legitimate deduction.

const KEY = 'proctoring_glitch_refresh'
const TTL_MS = 60 * 1000

const readMarker = () => {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    return JSON.parse(raw)
}

const mark = slug => {
    try {
        localStorage.setItem(KEY, JSON.stringify({ slug, at: Date.now() }))
    } catch (_) {}
}

// True if a fresh marker for this slug exists; clears expired/malformed markers.
const peek = slug => {
    try {
        const { slug: markedSlug, at } = readMarker() || {}
        const isFresh = typeof at === 'number' && Date.now() - at < TTL_MS
        if (!isFresh) clear()
        return markedSlug === slug && isFresh
    } catch (_) {
        clear()
        return false
    }
}

const clearForSlug = slug => {
    if (!slug) return

    try {
        const { slug: markedSlug } = readMarker() || {}
        if (markedSlug === slug) clear()
    } catch (_) {
        clear()
    }
}

const clear = () => {
    try {
        localStorage.removeItem(KEY)
    } catch (_) {}
}

export default { mark, peek, clear, clearForSlug }
